import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import AddNewButton, { AddNewButtonProps } from './AddNewButton';

interface ReportsHeaderProps extends AddNewButtonProps {
  text: string;
  count: number;
  children?: React.ReactNode | React.ReactNode[];
}

const StyledDiv = styled.div`
  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title {
      display: flex;
      align-items: center;
      .title-heading {
        margin-right: ${SPACERS.tiny};
        margin-bottom: 0;
      }
      .count {
        font-size: 28px;
      }
    }
    .add-new-button {
      display: flex;
      min-width: 140px;
      align-items: center;
      justify-content: center;
      .add-new-button-icon {
        margin-left: ${SPACERS.tiny};
      }
    }
  }
`;

const ReportsHeader: React.FC<ReportsHeaderProps> = ({
  text,
  count,
  addButtonText,
  onAdd,
  children,
}) => {
  return (
    <StyledDiv>
      <div className="header">
        <div className="title">
          <TrueImpactText variant="heading-page" className="title-heading">
            {text}
          </TrueImpactText>
          {count > 0 && (
            <TrueImpactText className="count">({count})</TrueImpactText>
          )}
        </div>
        <AddNewButton onAdd={onAdd} addButtonText={addButtonText} />
      </div>
      <div>{children}</div>
    </StyledDiv>
  );
};

export default ReportsHeader;
